import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { AlertService, AuthenticationService, ItemsToSellService, ItemToSell, ItemToSellState, GMailService } from '../../../../_services';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'delete-item-confirmation-dialog',
  templateUrl: './delete-item-confirmation-dialog.html',
})
export class DeleteItemConfirmationDialog {
  constructor(
    public dialogRef: MatDialogRef<DeleteItemConfirmationDialog>
  ) {}

}

@Component({
  selector: 'item-picker',
  templateUrl: './item-picker.component.html',
  styleUrls: ['./item-picker.component.scss']
})
export class ItemPickerComponent implements OnInit, OnDestroy {
  
  @Output() onListRefreshed: EventEmitter<string> = new EventEmitter();
  
  public items: ItemToSell[] = [];
  private _loading: boolean = false;
  private polling: boolean = false;
  private pollingTimer: any;
  
  @Input() hasGMailIntegration: boolean = false;
  
  constructor(
    private itemsToSellService: ItemsToSellService,
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private gmailService: GMailService
  ) {}
  
  ngOnDestroy(): void {
    if (this.pollingTimer) {
      clearTimeout(this.pollingTimer);
    }
  }
  
  async reload(): Promise<void> {
    this._loading = true; 
    await this.loadItems();
    this.schedulePoll();
  }
  
  async loadItems(): Promise<void> {
    
    this.items = await this.itemsToSellService.list({ owner: [this.authenticationService.getLoggedInUser()!.id!], limit: 1000 });
  }
  
  private async hasOngoingScan(): Promise<boolean> {
    return (await this.gmailService.listOngoingScans()).length > 0;
  }
  
  async refreshItems(): Promise<void> {
    
    const freshItems = await this.itemsToSellService.list({ owner: [this.authenticationService.getLoggedInUser()!.id!], limit: 1000 });
   
    this.updateExistingItems(freshItems);
    this.addNewItems(freshItems);
    
    this.onListRefreshed.emit();
  }
  
  private addNewItems(freshItems: ItemToSell[]) {
    
    const copyOfItems = [...this.items];
    
    freshItems
      .filter(item => !copyOfItems.find(existingItem => existingItem.id === item.id))
      .forEach(newItem => {
        console.log("Adding fresh item " + newItem.id);
        copyOfItems.push(newItem);
      });
      
    this.items = copyOfItems;
  }
  
  private updateExistingItems(freshItems: ItemToSell[]) {
    this.items
      .forEach((oldItem, index) => {
        
        if (oldItem.state !== ItemToSellState.DRAFT) {
          return;
        }
        
        const freshItem = freshItems.filter(freshItem => freshItem.id === oldItem.id);
        
        if (freshItem.length === 0 || freshItem[0].state === ItemToSellState.DRAFT) {
          return;
        }
        
        console.log("Updating item " + oldItem.id + " with fresh copy from server");
        //this.items[index] = freshItem[0];
        this.refreshItem(this.items[index], freshItem[0]);
      });
  }
  
  private refreshItem(oldItem: ItemToSell, freshItem: ItemToSell) {
    oldItem.state = freshItem.state;
    oldItem.title = freshItem.title;
    oldItem.description = freshItem.description;
    oldItem.pictures = freshItem.pictures;
  }
  
  private async schedulePoll(): Promise<void> {
    
    if (this.polling) {
      console.log("Already polling");
      return;
    }
    
    this.pollingTimer = setTimeout(() => { this.poll() }, 10000);
    this.polling = true;
  }
  
  async poll(): Promise<void> {
    
    if (await this.hasOngoingScan()) {
      
      console.log("Polling items");
      await this.refreshItems();
      
      console.log("Scheduling another poll");
      this.pollingTimer = setTimeout(() => { this.poll() }, 10000);      
    } else {
      console.log("No more need to poll");
      this.polling = false;
      this._loading = false;
    }
  }
  
  ngOnInit() {
    this.reload();
  }
  
  get loading() {
    return this._loading;
  }
  
  async deleteItem(item: ItemToSell) {

    const dialogRef = this.dialog.open(DeleteItemConfirmationDialog, {
    });

    const result = await firstValueFrom(dialogRef.afterClosed());
    
    if (result) {
      console.log('The dialog was closed');
      await this.itemsToSellService.delete(item.id);
      this.deleteLocalItem(item.id);
      this.alertService.showSuccess($localize `Item deleted`);
    };
  }
  
  private deleteLocalItem(id: number) {
    this.items = this.items.filter(item => item.id != id);
  }
}
